module.exports = __webpack_public_path__ + "img/草稿.ebe31cbf.svg";